/**
 * Basic field validators
 */

export function validateRequired(value) {
	return value?.trim() !== "";
}

export function validateEmail(value) {
	return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
}

export function minLength(value, min) {
	return value.length >= min;
}

export function maxLength(value, max) {
	return value.length <= max;
}

export function matchField(value1, value2) {
	return value1 === value2;
}

/**
 * Validate fields against rules
 * @param {HTMLFormElement} form
 * @param {Object} rules { fieldName: [ 'required', 'email', ... ] }
 * @returns Object { valid: boolean, errors: { field: message } }
 */
export function validateForm(form, rules) {
	const errors = {};
	let valid = true;

	for (const field in rules) {
		const input = form.elements[field];
		const value = input?.value || "";
		const fieldRules = rules[field];

		for (const rule of fieldRules) {
			if (rule === "required" && !isRequired(value)) {
				errors[field] = "This field is required";
				valid = false;
				break;
			}

			if (rule === "email" && !isValidEmail(value)) {
				errors[field] = "Invalid email address";
				valid = false;
				break;
			}

			if (rule.startsWith("min:")) {
				const min = parseInt(rule.split(":")[1], 10);
				if (!minLength(value, min)) {
					errors[field] = `Minimum ${min} characters required`;
					valid = false;
					break;
				}
			}

			if (rule.startsWith("max:")) {
				const max = parseInt(rule.split(":")[1], 10);
				if (!maxLength(value, max)) {
					errors[field] = `Maximum ${max} characters allowed`;
					valid = false;
					break;
				}
			}
		}
	}

	return { valid, errors };
}

/**
 * Show validation errors inline
 */
export function showValidationErrors(form, errors) {
	Object.keys(errors).forEach((field) => {
		const input = form.elements[field];
		if (!input) return;

		let errorEl = input.nextElementSibling;
		if (!errorEl || !errorEl.classList.contains("form-error")) {
			errorEl = document.createElement("div");
			errorEl.className = "form-error text-sm text-red-600 mt-1";
			input.parentNode.appendChild(errorEl);
		}
		errorEl.textContent = errors[field];
	});
}

/**
 * Clear existing inline validation errors
 */
export function clearValidationErrors(form) {
	const errors = form.querySelectorAll(".form-error");
	errors.forEach((el) => el.remove());
}
